var evaluateCondition = function (conditionalValue) {
    if (!conditionalValue) {
        return false;
    }
    if (Array.isArray(conditionalValue)) {
        return conditionalValue.length > 0;
    }
    return !!conditionalValue;
};
export var shouldRender = function (module) {
    var show = module.show, hide = module.hide, displayCondition = module.displayCondition;
    if (displayCondition === 'show' && !evaluateCondition(show))
        return false;
    if (displayCondition === 'hide' && evaluateCondition(hide))
        return false;
    return true;
};
//# sourceMappingURL=should-render.js.map